export default __webpack_public_path__ + "static/media/haxxpower.7066ddf1.png";